export default __webpack_public_path__ + "static/trevor-13281fe308b1c56a17635313a888736f.jpg";